import React, { useState } from 'react';
import { authAxios } from '@/lib/api';
import { logError } from '@/lib/logger';
import { useApiData } from '@/hooks/useApiData';
import TestimonialForm from './testimonials/TestimonialForm';
import TestimonialCard from './testimonials/TestimonialCard';

const EMPTY = { name: '', company: '', country: '', text: '', rating: 5, published: true };
const NO_ITEMS = [];
const pickFields = (t) => ({ name: t.name, company: t.company, country: t.country, text: t.text, rating: t.rating, published: t.published });

export default function TestimonialsManager() {
  const { data: testimonials, loading, reload } = useApiData('/api/testimonials?published_only=false', NO_ITEMS, authAxios);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);

  const resetForm = () => { setEditing(null); setForm(EMPTY); };

  const handleSave = async () => {
    if (!form.name || !form.text) return;
    try {
      if (editing) await authAxios.put(`/api/testimonials/${editing}`, form);
      else await authAxios.post('/api/testimonials', form);
      resetForm();
      reload();
    } catch (error) { logError('Failed to save testimonial:', error); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this testimonial?')) return;
    try {
      await authAxios.delete(`/api/testimonials/${id}`);
      reload();
    } catch (error) { logError('Failed to delete testimonial:', error); }
  };

  const startEdit = (t) => { setEditing(t.id); setForm(pickFields(t)); };

  if (loading) return <div className="text-center py-12 text-earth/40 font-sans" data-testid="testimonials-loading">Loading testimonials...</div>;

  return (
    <div className="space-y-5" data-testid="testimonials-manager">
      <TestimonialForm form={form} setForm={setForm} isEditing={Boolean(editing)} onSave={handleSave} onCancel={resetForm} />
      <div className="space-y-3">
        {testimonials.length === 0 ? (
          <p className="text-center py-8 text-earth/30 font-sans text-sm" data-testid="testimonials-empty">No testimonials yet. Add your first buyer testimonial above.</p>
        ) : (
          testimonials.map(t => <TestimonialCard key={t.id} testimonial={t} onEdit={startEdit} onDelete={handleDelete} />)
        )}
      </div>
    </div>
  );
}
